import { createContext, useContext } from "react";
import { createShopApi } from "./pcwApi";

// The shop-floor job clocks — the same dashboard over each shop's own
// database. Mirrors server/routes/api/PCW/shopClocks.js. The Mill's job
// clock is a separate tablet from the Mill's UKG attendance iPad.
export const SHOP_CLOCKS = {
  pcw: {
    key: "pcw",
    // In copy: "PCW workers", "the PCW tablet".
    name: "PCW",
    title: "PCW Hours",
    place: "Priebe's Creative Woodworking",
    path: "/pcw",
    roles: ["Admin", "PCW Admin"],
    // CSV file names: pcw-punches-….csv
    fileSlug: "pcw",
    // Workers have a UKG # and the server's evening payroll check ends
    // job punches left open after they clocked out (payrollPunchCheck.js).
    payrollCheck: true,
    api: createShopApi("/api/pcw"),
  },
  mill: {
    key: "mill",
    name: "Mill Shop",
    title: "Mill Shop Hours",
    place: "Mill - Fort Wayne",
    path: "/mill-shop",
    roles: ["Admin", "Mill Admin"],
    fileSlug: "mill-shop",
    api: createShopApi("/api/mill"),
  },
};

const ShopClockContext = createContext(SHOP_CLOCKS.pcw);

export const ShopClockProvider = ShopClockContext.Provider;

/**
 * The shop the dashboard is showing, as { shop, api } — shop is the
 * SHOP_CLOCKS entry ({ key, name, title, roles, … }), api its endpoints.
 */
export const useShopClock = () => {
  const shop = useContext(ShopClockContext);
  return { shop, api: shop.api };
};
